"use client"
import { Slide, ToastContainer as Container } from "react-toastify"

type ToasterProps = React.ComponentProps<typeof Container>

const ToastContainer = ({ ...props }: ToasterProps) => {
  return (
    <Container
      position="top-right"
      autoClose={5000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      transition={Slide}
      {...props}
    />
  )
}

export { ToastContainer }
